module.exports = __webpack_public_path__ + "img/frame_4.75ed2416.png";